<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="field-value">{{ formattedValue }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      requirementGroup: null,
    }
  },
  computed: {
    ...mapState('settings', ['school']),
    formattedValue() {
      if (this.requirementGroup) {
        return (
          this.requirementGroup.catalogDisplayName ||
          this.requirementGroup.displayName ||
          this.requirementGroup.descriptionLong ||
          this.emptyValuePlaceholder
        )
      }
      return this.value || this.emptyValuePlaceholder
    },
    emptyValuePlaceholder() {
      return this.question?.config?.emptyValuePlaceholder || '-'
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value) return this.loadRelatedData()
      },
    },
  },
  methods: {
    async loadRelatedData() {
      try {
        const { data = {} } = await this.$axios.$get(
          `/${this.school}/requirementGroups/${
            this.value
          }?returnFields=code,catalogDisplayName,displayName,descriptionLong`
        )
        this.requirementGroup = data[this.value] || null
      } catch (e) {
        this.$bugsnag.notify(e)
        console.error('error lodaing requirement group object')
      }
    },
  },
}
</script>
